import { Box, LinearProgress } from '@mui/material';

export default function InProgressBar({ message }: { message?: string }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: (theme) => theme.zIndex.drawer + 2,
        mt: { xs: -8.5, sm: -9.5 },
        pb: 2,
        textAlign: 'center',
        cursor: 'wait'
      }}
    >
      <LinearProgress sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }} />
      <p>{message}</p>
    </Box>
  );
}
